import { render, staticRenderFns } from "./task-list-tag-select.vue?vue&type=template&id=04869b5c&scoped=true"
import script from "./task-list-tag-select.vue?vue&type=script&lang=js"
export * from "./task-list-tag-select.vue?vue&type=script&lang=js"
import style0 from "./task-list-tag-select.vue?vue&type=style&index=0&id=04869b5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04869b5c",
  null
  
)

export default component.exports